import {CategoryHeadSeo} from '@aboutyou/logic-components';
import React, {StrictMode} from 'react';
import {Category} from './Category.eager';

// On the server we would wast resources if we render everything as the data is lost after the redirect that will happen.
// On the client we can handle this more graceful and just reuse the already requested data
export const CategoryLegacy: React.FC<React.PropsWithChildren> = process.browser
  ? Category
  : () => {
      return (
        <StrictMode>
          <CategoryHeadSeo />
        </StrictMode>
      );
    };
